import { __decorate } from "tslib";
import React, { cloneElement, Component, isValidElement } from 'react';
import { observer } from 'mobx-react';
import isObject from 'lodash/isObject';
import { TableQueryBarType } from '../Table';
import TableContext from '../TableContext';
import autobind from '../../_util/autobind';
import { getEditorByField, getPlaceholderByField } from '../../table/utils';
import TableProfessionalBar from './TableProfessionalBar';
import TableDynamicFilterBar from './TableDynamicFilterBar';
let PerformanceTableQueryBar = class PerformanceTableQueryBar extends Component {
    static get contextType() {
        return TableContext;
    }
    handleQueryReset() {
        const { tableStore: { dataSet: { queryDataSet }, }, } = this.context;
        if (queryDataSet) {
            const { current } = queryDataSet;
            if (current) {
                current.reset();
            }
            this.handleQuery();
        }
    }
    async handleQuery() {
        const { tableStore, tableStore: { dataSet, dataSet: { queryDataSet } }, } = this.context;
        if (tableStore.queryBar === TableQueryBarType.filterBar) {
            if (await dataSet.modifiedCheck(undefined, dataSet, 'query') && queryDataSet && queryDataSet.current && await queryDataSet.current.validate()) {
                return dataSet.query();
            }
        }
        else {
            return dataSet.query();
        }
    }
    getQueryFields() {
        const { tableStore: { dataSet, queryBar: { queryFields = {}, type } } } = this.context;
        const { queryDataSet } = dataSet;
        const result = [];
        if (queryDataSet) {
            const { fields, current, props: { fields: propFields = [] } } = queryDataSet;
            const cloneFields = fields.toJS();
            const processField = (field, name) => {
                if (!field.get('bind', current) && !name.includes('__tls')) {
                    const element = queryFields[name];
                    let filterBarProps = {};
                    if (type === TableQueryBarType.filterBar) {
                        const placeholder = isValidElement(element) && element.props.placeholder ? element.props.placeholder : getPlaceholderByField(field, current);
                        filterBarProps = {
                            placeholder,
                            border: false,
                            clearButton: true,
                        };
                    }
                    const props = {
                        key: name,
                        name,
                        dataSet: queryDataSet,
                        isFlat: type === TableQueryBarType.filterBar,
                        ...filterBarProps,
                    };
                    result.push(isValidElement(element)
                        ? cloneElement(element, props)
                        : cloneElement(getEditorByField(field, current, type !== TableQueryBarType.professionalBar, type === TableQueryBarType.filterBar), {
                            ...props,
                            ...(isObject(element) ? element : {}),
                        }));
                }
            };
            propFields.forEach(({ name }) => {
                if (name) {
                    const field = cloneFields.get(name);
                    if (field) {
                        cloneFields.delete(name);
                        processField(field, name);
                    }
                }
            });
            cloneFields.forEach((field, name) => {
                processField(field, name);
            });
        }
        return result;
    }
    renderProfessionalBar(props) {
        const { tableStore: { prefixCls } } = this.context;
        return React.createElement(TableProfessionalBar, Object.assign({ key: "toolbar", prefixCls: prefixCls }, props));
    }
    renderDynamicFilterBar(props) {
        const { tableStore: { prefixCls } } = this.context;
        // @ts-ignore
        return React.createElement(TableDynamicFilterBar, Object.assign({ key: "toolbar", prefixCls: prefixCls }, props));
    }
    render() {
        const { tableStore: { queryBar, dataSet } } = this.context;
        if (dataSet) {
            const queryFields = this.getQueryFields();
            const { queryDataSet } = dataSet;
            const props = {
                ...queryBar,
                queryFields,
                queryDataSet,
            };
            if (typeof queryBar.renderer === 'function') {
                return queryBar.renderer(props);
            }
            switch (queryBar.type) {
                case TableQueryBarType.professionalBar:
                    return this.renderProfessionalBar(props);
                case TableQueryBarType.filterBar:
                    return this.renderDynamicFilterBar(props);
                default:
            }
        }
        return null;
    }
};
PerformanceTableQueryBar.displayName = 'PerformanceTableQueryBar';
PerformanceTableQueryBar.defaultProps = {
    queryFieldsLimit: 3,
};
__decorate([
    autobind
], PerformanceTableQueryBar.prototype, "handleQueryReset", null);
__decorate([
    autobind
], PerformanceTableQueryBar.prototype, "handleQuery", null);
PerformanceTableQueryBar = __decorate([
    observer
], PerformanceTableQueryBar);
export default PerformanceTableQueryBar;
